"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.samplePropertyCompact2 = exports.samplePropertyCompact = void 0;
exports.samplePropertyCompact = {
    id: 367009,
    buildingId: 2121,
    buildingName: 'Victoria Court',
    buildingNameEng: 'Victoria Court',
    latitude: '',
    longitude: '',
    streetNo: '50-56',
    streetName: 'Hing Fat Street',
    districtName: 'Causeway Bay',
    bedrooms: 3,
    bathrooms: 2,
    totalMaidRoom: 1,
    netSize: 1516,
    grossSize: 0,
    leasePrice: 68,
    salePrice: 0,
    isSaleSTO: 0,
    isLeaseSTO: 0,
    leasepersqftNet: 45,
    leasepersqftGross: 0,
    sellpersqftNet: 0,
    sellpersqftGross: 0,
    listingTypeId: 2,
    floorName: 'Medium',
    lastUpdatedDate: '2018-06-21T00:00:00',
    // tslint:disable-next-line:max-line-length
    exclusivePhoto: '',
    propertyPhoto: '^367009_636651927636459881.JPG|PP^367009_636651927569691764.JPG|PP^367009_636651927604635825.JPG|PP^367009_636651928335965110.JPG|PP^367009_636651928907550114.JPG|PP^367009_636651928301801050.JPG|PP^367009_636651929286006779.JPG|PP^367009_636651927908992360.JPG|PP^367009_636651927937852411.JPG|PP^367009_636651927974668475.JPG|PP^367009_636651928035820583.JPG|PP^367009_636651928943430177.JPG|PP',
    isSoleAgent: 0,
    isJointSoleAgent: 0,
    leaseInc: 'I',
    areaName: 'Hong Kong Island',
    districtId: 89,
    builtYear: 1964,
    isRelated: false,
    isVirtual: false,
};
exports.samplePropertyCompact2 = {
    id: 367007,
    buildingId: 9224,
    buildingName: "95-97 Queen's Road East",
    buildingNameEng: "95-97 Queen's Road East",
    latitude: '',
    longitude: '114.170098',
    streetNo: '95-97',
    streetName: "Queen's Road East",
    districtName: 'Wan Chai',
    bedrooms: 1,
    bathrooms: 1,
    totalMaidRoom: 0,
    netSize: 443,
    grossSize: 0,
    leasePrice: 23.5,
    salePrice: 0,
    isSaleSTO: 0,
    isLeaseSTO: 0,
    leasepersqftNet: 53,
    leasepersqftGross: 0,
    sellpersqftNet: 0,
    sellpersqftGross: 0,
    listingTypeId: 2,
    floorName: 'Medium',
    lastUpdatedDate: '2018-06-21T00:00:00',
    // tslint:disable-next-line:max-line-length
    exclusivePhoto: '',
    propertyPhoto: '^367007_636651860047781168.JPG|PP^367007_636651860118137292.JPG|PP^367007_636651860224373478.JPG|PP^367007_636651860017205114.JPG|PP^367007_636651860188181415.JPG|PP^367007_636651860082569229.JPG|PP^367007_636651860255729533.JPG|PP^367007_636651860154485356.JPG|PP',
    isSoleAgent: 0,
    isJointSoleAgent: 0,
    leaseInc: 'I',
    areaName: 'Hong Kong Island',
    districtId: 89,
    builtYear: 1965,
    isRelated: false,
    isVirtual: false,
};
